import React, { useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { loadSettings } from './CartShippingTeaser';
import { minOrderBlock } from '../../lib/minOrder';
import { shippingCategoryFor } from '../../lib/countries';

// Early warning in the basket drawer: shipped live-animal orders need the admin-set minimum
// (food-only baskets are exempt). Collection is still allowed, so the Checkout button stays usable.
export const CartMinOrderNote = ({ items, totalPrice }) => {
  const [settings, setSettings] = useState(null);
  useEffect(() => { loadSettings().then(setSettings); }, []);

  const block = settings ? minOrderBlock(settings, totalPrice, shippingCategoryFor(items)) : null;
  if (!block) return null;

  return (
    <div
      className="text-xs p-2.5 rounded-lg border bg-amber-50 border-amber-300 text-amber-800 flex items-start gap-2"
      data-testid="cart-min-order-note"
    >
      <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
      <p>
        <span className="font-semibold">Shipping minimum not reached. </span>
        <span data-testid="cart-min-order-message">{block.message}</span>
      </p>
    </div>
  );
};

export default CartMinOrderNote;
